import { Button, Stack } from '@mui/material';

interface SelectDeselectActionGroupProps {
  onDelete: () => void;
  onCancel: () => void;
  onSelectAll: () => void;
  allSelected: boolean;
  deleteButtonLabel?: string;
  deleteDisabled?: boolean;
}

function SelectDeselectActionGroup({
  onDelete,
  onCancel,
  onSelectAll,
  allSelected,
  deleteButtonLabel,
  deleteDisabled,
}: SelectDeselectActionGroupProps) {
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'stretch',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1,
        width: '100%',
      }}
      data-testid="select-deselect-action-group"
    >
      <Button
        onClick={onCancel}
        sx={{
          flex: 1,
          minWidth: '20%',
        }}
        variant="outlined"
        data-testid="delete-group-cancel-button"
      >
        Cancel
      </Button>

      <Button
        variant="outlined"
        onClick={onSelectAll}
        sx={{
          flex: 1,
          minWidth: '30%',
          whiteSpace: 'nowrap',
        }}
        data-testid="delete-group-select-deselect-all-button"
      >
        {allSelected ? 'Deselect All' : 'Select All'}
      </Button>

      <Button
        onClick={onDelete}
        disabled={deleteDisabled}
        sx={{
          flexGrow: 1,
          minWidth: '45%',
        }}
        data-testid="delete-group-delete-button"
      >
        {deleteButtonLabel}
      </Button>
    </Stack>
  );
}

export default SelectDeselectActionGroup;

SelectDeselectActionGroup.defaultProps = {
  deleteButtonLabel: 'Delete',
  deleteDisabled: false,
};
